import {
  formatPhoneBel,
  formatPhoneGeo,
  formatPhoneHun,
  formatPhoneKaz,
  formatPhoneLtu,
  formatPhonePol,
  formatPhoneUkr,
} from 'utils';

export const MONTHS_ENG = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const MONTHS_RU = [
  'Январь',
  'Февраль',
  'Март',
  'Апрель',
  'Май',
  'Июнь',
  'Июль',
  'Август',
  'Сентябрь',
  'Октябрь',
  'Ноябрь',
  'Декабрь',
];

export enum DateInputConstant {
  MILLENNIUM = 2,
  CENTURY = 0,
  MAX_DAY_IN_MONTH = 31,
  MAX_MONTH_IN_YEAR = 12,
  MIN_AVAILABLE_YEAR = 2018,
  MAX_AVAILABLE_YEAR = 2035,
  TEMPLATE = 'dd/mm/yyyy',
}

export enum DiscountLimit {
  MIN_MIN_SIZE = 1,
  MAX_MIN_SIZE = 99,
  MAX_SIZE = 100,
  STEP = 0.1,
}

export const DEFAULT_END_DATE_EXISTING = true;

export enum CountryWithPhoneFormat {
  Ukraine = 'Ukraine',
  Belarus = 'Belarus',
  Poland = 'Poland',
  Kazakhstan = 'Kazakhstan',
  Lithuania = 'Lithuania',
  Georgia = 'Georgia',
  Hungary = 'Hungary',
}

type CountryPhoneFormatInfo = Partial<
  Record<
    string,
    {
      countryCode: string;
      numericLength: number | number[];
      formatFunction: (inputNumbers: string) => string;
    }
  >
>;

export const COUNTRIES_PHONE_FORMAT: CountryPhoneFormatInfo = {
  [CountryWithPhoneFormat.Ukraine]: {
    countryCode: '+380',
    numericLength: 12,
    formatFunction: formatPhoneUkr,
  },
  [CountryWithPhoneFormat.Belarus]: {
    countryCode: '+375',
    numericLength: 12,
    formatFunction: formatPhoneBel,
  },
  [CountryWithPhoneFormat.Poland]: {
    countryCode: '+48',
    numericLength: 11,
    formatFunction: formatPhonePol,
  },
  [CountryWithPhoneFormat.Kazakhstan]: {
    countryCode: '+7',
    numericLength: 11,
    formatFunction: formatPhoneKaz,
  },
  [CountryWithPhoneFormat.Lithuania]: {
    countryCode: '+370',
    numericLength: 11,
    formatFunction: formatPhoneLtu,
  },
  [CountryWithPhoneFormat.Georgia]: {
    countryCode: '+995',
    numericLength: 12,
    formatFunction: formatPhoneGeo,
  },
  [CountryWithPhoneFormat.Hungary]: {
    countryCode: '+36',
    numericLength: [10, 11],
    formatFunction: formatPhoneHun,
  },
};

export const DISCOUNT_SIZE_PATTERN = /^\d{0,3}\.?\d{0,3}$/;

export const DISCOUNT_SIZE_ONLY_DIGITS_PATTERN = /[\d.]/;

export const DISCOUNT_SIZE_DIGIT_WHOLE = /^[1-9]\d?\.\d$/;
